import { Injectable } from '@angular/core';
import { Http, Response, Headers, ResponseContentType } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import { CONFIGURATION } from '../app.config';

@Injectable()
export class DatasheetService {
  
 
  private apiurl = CONFIGURATION.baseServiceUrl + 'datasheettracker/';

  constructor(private _http: Http) { }

  getFilterData() {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'referencedata', { headers: headers }).map((response: Response) => response.json())
  }
  sendingData(mainObj:any) {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.apiurl + 'reportdata', mainObj, { headers: headers })
      .map((response: Response) => response.json())
  }
  

  getControllGroup(cg: any, fname: any, lName: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'controlgroup?Ssn=' + cg + '&FirstName=' + fname + '&LastName=' + lName, { headers: headers })
      .map((response: Response) => response.json())
  }

  getTaxyears(ssn: any, cg: any, fname: any, lName: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'taxyear?Ssn=' + ssn + '&ControlGroup=' + cg + '&FirstName=' + fname + '&LastName=' + lName, { headers: headers })
      .map((response: Response) => response.json())
  }
  getreportData(ssn: any, fname: any, lName: any, cg: any, year: any, ): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.get(this.apiurl + 'reportdata?Ssn=' + ssn + '&FirstName=' + fname + '&LastName=' + lName +
      '&ControlGroup=' + cg + '&TaxYear=' + year, { headers: headers })
      .map((response: Response) => response.json())
  }

  getDataSheetReportData(data: any): Observable<any> {
    const headers = new Headers();
    headers.append('Client-Id', 'REPORTING-PORTAL-API-CLIENT');
    headers.append('Client-Secret', '0667b514-28a8-4928-9aa4-1ffe290ebcd2');
    return this._http.post(this.apiurl + `v2/reportdata`,data, { headers: headers })
      .map((res: Response) => res.json())
  }

}


// WEBPACK FOOTER //
// ./src/app/datasheet-tracker/datasheet.service.ts